<h2 mat-dialog-title>Add Pool Point</h2>
<mat-dialog-content>
    <form [formGroup]="poolPointForm" (ngSubmit)="submit()">
        <!-- Pool Point Info -->
        <mat-form-field>
            <mat-label>Pool Point Name</mat-label>
            <input matInput formControlName="pool_point_name">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Pool Point ID</mat-label>
            <input matInput formControlName="pool_point_id">
        </mat-form-field>
        <app-contact-autocomplete
            placeholder="Search contacts..." 
            [type]="'shipper_contact_list'" 
            [formControl]="poolPointContactControl" 
            (selected)="onPoolPointContactSelected($event)"
        ></app-contact-autocomplete>
        <mat-form-field appearance="outline" color="primary">
            <mat-label>Pool Point Address</mat-label>
            <mat-select formControlName="pool_point_address_uuid">
                <mat-option *ngFor="let address of poolPointAddressOptions" [value]="address.value">{{address.label}}</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Client Info -->
        <div class="clients-container" formArrayName="clients">
            <h3>Clients</h3>
            <form *ngFor="let client of clients.controls; let i = index" [formGroupName]="i">
                <mat-form-field appearance="outline">
                    <mat-label>Client Name</mat-label>
                    <input matInput formControlName="pool_point_client_name">
                </mat-form-field>
                <app-contact-autocomplete 
                    placeholder="Search clients..." 
                    [type]="'customer_contact_list'" 
                    [formControl]="getPoolPointClientContactControl(asFormGroup(client))" 
                    (selected)="onClientContactSelected($event, i)"
                ></app-contact-autocomplete>
                <button mat-button (click)="addStore(asFormGroup(client))">Add Store</button>
                <button mat-button (click)="removeClient(i)">Remove</button>

                <!-- Store Info -->
                <div class="stores-container" formArrayName="stores">
                    <h4>Stores</h4>
                    <form *ngFor="let store of getStores(asFormGroup(client)).controls; let j = index" [formGroupName]="j">
                        <mat-form-field appearance="outline">
                            <mat-label>Store Number</mat-label>
                            <input matInput formControlName="pool_point_store_number">
                        </mat-form-field>
                        <app-contact-autocomplete 
                            placeholder="Search stores..." 
                            [type]="'consignee_contact_list'" 
                            [formControl]="getPoolPointStoreContactControl(asFormGroup(store))" 
                            (selected)="onStoreContactSelected($event, i, j)"
                        ></app-contact-autocomplete>
                        <mat-form-field appearance="outline">
                            <mat-label>Store Address</mat-label>
                            <mat-select formControlName="pool_point_store_address_uuid">
                                <mat-option *ngFor="let address of storeAddressOptions[j]" [value]="address.value">{{address.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button mat-button (click)="removeStore(asFormGroup(client), j)">Remove</button>
                    </form>
                </div>
            </form>
        </div>
    </form>
</mat-dialog-content>
<mat-action-list>
    <button mat-button (click)="addClient()">Add Client</button>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-raised-button (click)="submit()" color="primary">Submit</button>
</mat-action-list>